import constants from '@/services/constants'

const role = constants.USER_ROLE
let subGroupMaster = function() {
  return  [
    {
      label: 'Assigned Location',
      target: { name: 'location.assign' }
    },
    {
      label: 'Buyer',
      target: { name: 'buyer.index' }
    },
    {
      label: 'Buyer Location',
      target: { name: 'location.buyer' }
    },
    {
      label: 'Company',
      target: { name: 'location.company' }
    },
    {
      label: 'Delivery To',
      target: { name: 'location.onshore' }
    },
    {
      label: 'Dictionary',
      target: { name: 'location.dictionary' }
    },
    {
      label: 'Justification',
      target: { name: 'justification.index' }
    },
    // {
    //   label: 'Material Group',
    //   target: { name: 'materialgroup.index' }
    // },
    {
      label: 'Material Last Location',
      target: { name: 'location.field' }
    },
    {
      label: 'Material Type',
      target: { name: 'materialtype.index' }
    },
    {
      label: 'Partner Share',
      target: { name: 'partner.share' }
    },
    {
      label: 'Platform',
      target: { name: 'location.platform' }
    },
    {
      label: 'Proposal',
      target: { name: 'proposal.index' }
    },
    {
      label: 'Supplier',
      target: { name: 'supplier.index' }
    },
    {
      label: 'Waste Contractor',
      target: { name: 'wastecontractor.index' }
    },
    /*{
      label: 'Search Po',
      target: { name: 'location.searchpo' }
    },*/
    {
      label: 'Modify Type',
      target: { name: 'location.modifytype' }
    },
    {
      label: 'AFE Allocation',
      target: { name: 'jdechildafe.index' }
    },
    {
      label: 'Bank Account',
      target: { name: 'bankaccount.index' }
    },
    {
      label: 'Final Refurbish',
      target: { name: 'finalrefurbish.index' }
    }
  ].sort((a, b) => {
    if(a.label > b.label)
      return 1
    if(a.label < b.label)
      return -1
    return 0
  })
  
}
const menu = [
// ---- RMR ---- //
  {
    label: 'RMR',
    target: { name: 'rmr.index' },
    role: [
      // Access
      role.GUEST,
      role.APPROVER,
      role.WH_SURPLUS,
      role.WH_DISPOSAL,
      role.OWS,
      role.FINANCE_STOCK,
      role.FINANCE_NONSTOCK,
      role.INVENTORY_SPECIALIST,
      role.DOA_APPROVER,
      role.PGPA,
      role.CUSTOM,
      role.INVOICE_APPROVER,
      role.FINANCE_AR,
      role.STOCK_ADJ,
      role.INVENTORY_WF,
      role.INVENTORY_WF_SUP,
      role.ADMIN,
      role.OWS_SUP,
      role.FINANCE_SUP,
      // Do not access
      !role.WESTE_CONTRACTOR, !role.BUYER
    ],
    subGroup: []
  },
  // ---- Receive Material ---- //
  {
    label: 'Receive Material',
    target: { name: 'wh.index' },
    role: [
      // role.WH, role.INVENTORY_SPECIALIST, role.ADMIN
    ],
    subGroup: [
      {
        label: 'Surplus',
        target: {
          name: 'wh.filter',
          params: {
            returntype: constants.RETURN_TYPE.SURPLUS
          }
        },
        role: [
          // Access
          role.ADMIN,
          role.WH_DISPOSAL,
          role.WH_SURPLUS,
          role.INVENTORY_SPECIALIST,
          role.OWS,
          role.OWS_SUP,
          role.REQUESTER,
          role.GUEST,
          role.APPROVER,
          role.FINANCE_STOCK,
          role.FINANCE_NONSTOCK,
          role.FINANCE_SUP,
          role.PGPA,
          role.CUSTOM,
          role.INVOICE_APPROVER,
          role.FINANCE_AR,
          role.STOCK_ADJ,
          role.DOA_APPROVER,
          role.INVENTORY_WF,
          role.INVENTORY_WF_SUP,
          // Do not access
          !role.WESTE_CONTRACTOR, !role.BUYER
        ]
      },
      {
        label: 'Disposal',
        target: {
          name: 'wh.filter',
          params: {
            returntype: constants.RETURN_TYPE.DISPOSAL
          }
        },
        role: [
          // Access
          role.ADMIN,
          role.WH_DISPOSAL,
          role.WH_SURPLUS,
          role.INVENTORY_SPECIALIST,
          role.OWS,
          role.OWS_SUP,
          role.REQUESTER,
          role.GUEST,
          role.APPROVER,
          role.FINANCE_STOCK,
          role.FINANCE_NONSTOCK,
          role.FINANCE_SUP,
          role.PGPA,
          role.CUSTOM,
          role.INVOICE_APPROVER,
          role.FINANCE_AR,
          role.STOCK_ADJ,
          role.DOA_APPROVER,
          role.INVENTORY_WF,
          role.INVENTORY_WF_SUP,
          // Do not access
          !role.WESTE_CONTRACTOR, !role.BUYER
        ]
      },
      {
        label: 'Repair/Return',
        target: {
          name: 'wh.filter',
          params: {
            returntype: constants.RETURN_TYPE.REPAIR_RETURN
          }
        },
        role: [
          // Access
          role.ADMIN,
          role.WH_DISPOSAL,
          role.WH_SURPLUS,
          role.INVENTORY_SPECIALIST,
          role.OWS,
          role.OWS_SUP,
          role.REQUESTER,
          role.GUEST,
          role.APPROVER,
          role.FINANCE_STOCK,
          role.FINANCE_NONSTOCK,
          role.FINANCE_SUP,
          role.PGPA,
          role.CUSTOM,
          role.INVOICE_APPROVER,
          role.FINANCE_AR,
          role.STOCK_ADJ,
          role.DOA_APPROVER,
          role.INVENTORY_WF,
          role.INVENTORY_WF_SUP,
          // Do not access
          !role.WESTE_CONTRACTOR, !role.BUYER
        ]
      },
      {
        label: 'Courtesy',
        target: {
          name: 'wh.filter',
          params: {
            returntype: constants.RETURN_TYPE.COURTESY
          }
        },
        role: [
          // Access
          role.ADMIN,
          role.WH_DISPOSAL,
          role.WH_SURPLUS,
          role.INVENTORY_SPECIALIST,
          role.OWS,
          role.OWS_SUP,
          role.REQUESTER,
          role.GUEST,
          role.APPROVER,
          role.FINANCE_STOCK,
          role.FINANCE_NONSTOCK,
          role.FINANCE_SUP,
          role.PGPA,
          role.CUSTOM,
          role.INVOICE_APPROVER,
          role.FINANCE_AR,
          role.STOCK_ADJ,
          role.DOA_APPROVER,
          role.INVENTORY_WF,
          role.INVENTORY_WF_SUP,
          // Do not access
          !role.WESTE_CONTRACTOR, !role.BUYER
        ]
      },
      {
        label: 'Contaminate',
        target: {
          name: 'wh.filter',
          params: {
            returntype: constants.RETURN_TYPE.CONTAMINATE
          }
        },
        role: [
          // Access
          role.ADMIN,
          role.WH_DISPOSAL,
          role.WH_SURPLUS,
          role.INVENTORY_SPECIALIST,
          role.OWS,
          role.OWS_SUP,
          role.REQUESTER,
          role.GUEST,
          role.APPROVER,
          role.FINANCE_STOCK,
          role.FINANCE_NONSTOCK,
          role.FINANCE_SUP,
          role.PGPA,
          role.CUSTOM,
          role.INVOICE_APPROVER,
          role.FINANCE_AR,
          role.STOCK_ADJ,
          role.DOA_APPROVER,
          role.INVENTORY_WF,
          role.INVENTORY_WF_SUP,
          // Do not access
          !role.BUYER
        ]
      },
      {
        label: 'Issue Cleaned Item',
        target: {
          name: 'cleaning.index'
        },
        role: [
          // Access
          role.ADMIN,
          role.WH_DISPOSAL,
          role.WESTE_CONTRACTOR,
          role.INVENTORY_SPECIALIST
          // Do not access
    
        ]
      },
      {
        label: 'Receive Cleaned Item',
        target: {
          name: 'cleaning.receive'
        },
        role: [
          // Access
          //role.WESTE_CONTRACTOR,
          role.BUYER,
          role.GUEST,
          //role.APPROVER,
          //role.WH_SURPLUS,
          role.WH_DISPOSAL,
          //role.OWS,
          //role.FINANCE_STOCK,
          //role.FINANCE_NONSTOCK,
          role.INVENTORY_SPECIALIST,
          //role.DOA_APPROVER,
          //role.PGPA,
          //role.CUSTOM,
          //role.INVOICE_APPROVER,
          //role.FINANCE_AR,
          //role.STOCK_ADJ,
          //role.INVENTORY_WF,
          //role.INVENTORY_WF_SUP,
          role.ADMIN,
          // Do not access
        ]
      }
    ]
  },
  // ---- Disposal Material ---- //
  {
    label: 'Disposal Material',
    target: { name: 'material.index' },
    role: [
      role.FINANCE_STOCK,
      role.FINANCE_NONSTOCK,
      role.INVENTORY_SPECIALIST,
      role.DOA_APPROVER,
      role.STOCK_ADJ,
      role.FINANCE_SUP,
      role.PGPA,
      role.CUSTOM,
      role.INVOICE_APPROVER,
      role.FINANCE_AR,
      role.ADMIN,
      role.WH_DISPOSAL,
      role.WH_SURPLUS,
      role.INVENTORY_WF,
      role.INVENTORY_WF_SUP
    ],
    subGroup: [
      {
        label: 'Summary',
        target: { name: 'material.index' },
        role: []
      },
      {
        label: 'Mfd',
        target: { name: 'searchmfd' },
        role: [      
          role.FINANCE_STOCK,
          role.FINANCE_NONSTOCK,
          role.INVENTORY_SPECIALIST,
          role.DOA_APPROVER,
          role.STOCK_ADJ,
          role.FINANCE_SUP,
          role.PGPA,
          role.CUSTOM,
          role.INVOICE_APPROVER,
          role.FINANCE_AR,
          role.ADMIN,
          role.WH_DISPOSAL,
          role.WH_SURPLUS,
          role.INVENTORY_WF,
          role.INVENTORY_WF_SUP
        ]
      },
      {
        label: 'Invoice',
        target: { name: 'search.invoice' },
        role: [
          role.FINANCE_STOCK,
          role.FINANCE_NONSTOCK,
          role.INVENTORY_SPECIALIST,
          role.FINANCE_SUP,
          role.INVOICE_APPROVER,
          role.FINANCE_AR,
          role.ADMIN,
        ]
      },
    ]
  },
  // ---- Maintenance ---- //
  // {
  //   label: 'Maintenance',
  //   target: { name: 'maintenance' },
  //   role: [role.OWS],
  //   subGroup: [
  //     {
  //       label: 'Repair Return',
  //       target: { name: 'repairreturn.index' }
  //     }
  //   ]
  // },
  {
    label: 'Refurbished Material',
    target: { name: 'repairreturn.index' },
    role: [
      role.REQUESTER,
      role.OWS,
      role.WH_SURPLUS,
      role.OWS_SUP,
    ],
    subGroup: []
  },
  //{
  //  label: 'Report',
  //  target: { name: 'report.index'},
  //  role: [],
  //  subGroup: []
  //},
  // ---- search ---- //
  // {
  //   label: 'search',
  //   target: { name: 'search' },
  //   role: [

  //   ],
  //   subGroup: [
  //     {
  //       label: 'mfd',
  //       target: { name: 'searchmfd' }
  //     },
  //     {
  //       label: 'invoice',
  //       target: { name: 'search.invoice' }
  //     }
  //   ]
  // },
  // ---- admin ---- //
  {
    label: 'Admin',
    target: { name: 'admin' },
    role: [
      role.ADMIN,
      role.INVENTORY_SPECIALIST
    ],
    subGroup: [
      {
        label: 'Audit Log',
        target: { name: 'auditlog.index' }
      },
      {
        label: 'DOA Approval',
        target: { name: 'doaapproval.index' }
      },
      {
        label: 'User Management',
        target: { name: 'user.management' }
      },
      {
        label: 'Email Group',
        target: { name: 'emailgroup.index' }
      }
    ]
  },
  // ---- master ---- //
  {
    label: 'Master',
    target: { name: 'master' },
    role: [
      role.INVENTORY_SPECIALIST, role.ADMIN
    ],
    subGroup: subGroupMaster()
  },
  {
    label: 'Invoice Preparation',
    target: { name: 'invoicepreparation.index' },
    hideMenu: true,
    ignoreValidate: true,
    role: [],
    subGroup: []
  },
  {
    label: 'Material Contamanite',
    target: { name: 'material.contaminate' },
    hideMenu: true,
    ignoreValidate: true,
    role: [],
    subGroup: []
  }
]


export default menu
